<template>
  <div>
    <div class="container-fluid">
        <div class="text-center mb-3 d-flex justify-content-between">
          <div class="container-center d-flex align-items-center justify-content-center text-white">
              <h1><b>CONNESSIONE <br>IN CORSO</b></h1>
          </div>
        </div>    
    </div>
  </div>  
</template>

<script>
// @ is an alias to /src
import Auth from '../api/Auth'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'autologin',
  components: {
    
  },
  computed: {   
    ...mapState({
        user: state => state.User
    }),
  },
  methods: {
    ...mapActions('User', [
      'checkLogin'
    ]) 
  },
  mounted: function(){
    let apiAuth = new Auth();
    let token = this.$route.params.token;
    //console.log(token)
    apiAuth.autologin(token);
    this.checkLogin(() => {
      this.$router.push('/')
    });
  }
}
</script>

<style scoped>
    .container-center {
    height: 850px;
    width: 100%;
    }
    @media (max-width: 768px) {
      .container-center { 
        padding-left:0px;
        height: 600px;
      }
    }
</style>


